// Angular
import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';

// Libraries
import { DisplayGrid, GridsterConfig, GridsterItem } from 'angular-gridster2';
import { BehaviorSubject } from 'rxjs';

// Models
import { AppCleanup } from '../../../../../shared/models';
import { DashboardDto } from '../models/dashboard-dto';
import { DashboardItemDto } from '../models/dashboard-item-dto';

@Injectable({
	providedIn: 'root',
})
export class DashboardService extends AppCleanup {
	private dashboardUrl: string;

	protected itemAddedVar: BehaviorSubject<DashboardItemDto> = new BehaviorSubject<DashboardItemDto>(null);
	itemAdded$ = this.itemAddedVar.asObservable();
	protected gridsterItemUpdatedVar: BehaviorSubject<GridsterItem> = new BehaviorSubject<GridsterItem>(null);
	gridsterItemUpdated$ = this.gridsterItemUpdatedVar.asObservable();
	protected forceRefreshVar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	forceRefresh$ = this.forceRefreshVar.asObservable();
	protected resizeWidgetVar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	resizeWidget$ = this.resizeWidgetVar.asObservable();
	protected dashboardNeedsSavedVar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	dashboardNeedsSaved$ = this.dashboardNeedsSavedVar.asObservable();

	triggerSave$: EventEmitter<boolean> = new EventEmitter(false);
	triggerSaveAs$: EventEmitter<string> = new EventEmitter(null);

	protected gridsterConfigVar: BehaviorSubject<GridsterConfig> = new BehaviorSubject<GridsterConfig>(null);
	gridsterConfig$ = this.gridsterConfigVar.asObservable();

	constructor(private http: HttpClient) {
		super();
		this.dashboardUrl = `${this.apiUrl}api/dashboard`;
	}

	getDashboards(jobKey: string) {
		return this.http.get<DashboardDto[]>(`${this.dashboardUrl}/${jobKey}`);
	}

	createDashboard(jobKey: string, dashboard: DashboardDto) {
		return this.http.post<DashboardDto>(`${this.dashboardUrl}/${jobKey}`, dashboard);
	}

	updateDashboard(jobKey: string, dashboardDto: DashboardDto) {
		return this.http.put<DashboardDto>(`${this.dashboardUrl}/${jobKey}/dashboard`, dashboardDto);
	}

	setGridsterConfig(config: GridsterConfig) {
		this.gridsterConfigVar.next(config);
	}

	editDashboardMode() {
		let gridsterConfig = this.gridsterConfigVar.getValue();
		gridsterConfig.displayGrid = DisplayGrid.Always;
		gridsterConfig.draggable.enabled = true;
		gridsterConfig.resizable.enabled = true;
		gridsterConfig.api.optionsChanged();
		this.setGridsterConfig(gridsterConfig);
	}

	editDashboardModeCancel() {
		let gridsterConfig = this.gridsterConfigVar.getValue();
		gridsterConfig.displayGrid = DisplayGrid.None;
		gridsterConfig.draggable.enabled = false;
		gridsterConfig.resizable.enabled = false;
		gridsterConfig.api.optionsChanged();
		this.setGridsterConfig(gridsterConfig);
	}

	triggerGridsterItemEvent(gridsterItem: GridsterItem) {
		this.gridsterItemUpdatedVar.next(gridsterItem);
	}

	itemAdded(dashboardItemDto: DashboardItemDto) {
		this.itemAddedVar.next(dashboardItemDto);
	}

	forceRefresh() {
		this.forceRefreshVar.next(true);
	}

	dashboardSaveDisplay(display: boolean) {
		this.dashboardNeedsSavedVar.next(display);
	}

	triggerSave() {
		this.triggerSave$.emit(true);
	}

	triggerSaveAs(dashboardName: string) {
		this.triggerSaveAs$.emit(dashboardName);
	}

	triggerResize() {
		this.resizeWidgetVar.next(true);
	}
}
